module.exports = __webpack_public_path__ + "img/details.c1bbec92.png";